function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getCookie, setCookie } from 'typescript-cookie';
import fetch from 'unfetch';
import { getDomain } from '../../utils';
import { dateUtil } from './util/utils';
const isCredentialExpired = credential => dateUtil.getDateWithClockOffset().getTime() / 1000 > credential.expiration;
export class Auth {
  constructor(authConfig) {
    _defineProperty(this, "authConfig", void 0);
    _defineProperty(this, "credential", void 0);
    _defineProperty(this, "fetchingCredentials", void 0);
    this.authConfig = authConfig;
  }
  async getIdentityId() {
    const identityIdCacheKey = `aws.cognito.identity-id.${this.authConfig.identityPoolId}`;
    const cachedIdentityId = getCookie(identityIdCacheKey);
    if (cachedIdentityId && cachedIdentityId !== 'undefined') {
      return cachedIdentityId;
    }
    const url = `https://cognito-identity.${this.authConfig.region}.amazonaws.com`;
    const result = await fetch(url, {
      method: 'POST',
      headers: {
        'content-type': 'application/x-amz-json-1.1',
        'x-amz-target': 'AWSCognitoIdentityService.GetId'
      },
      body: JSON.stringify({
        IdentityPoolId: this.authConfig.identityPoolId
      })
    }).then(r => {
      if (r.ok) {
        return r;
      }
      return Promise.reject(r.statusText);
    }).then(r => r.json()).then(data => data.IdentityId).catch(() => undefined);
    setCookie(identityIdCacheKey, result, {
      domain: getDomain(),
      secure: true,
      expires: 365
    });
    return result;
  }
  async getCredential() {
    if (this.credential && !isCredentialExpired(this.credential)) {
      return this.credential;
    }
    if (this.fetchingCredentials) {
      return this.fetchingCredentials;
    }
    const fetchCredentials = async () => {
      try {
        const identityId = await this.getIdentityId();
        if (identityId === undefined) {
          return undefined;
        }
        const url = `https://cognito-identity.${this.authConfig.region}.amazonaws.com`;
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'content-type': 'application/x-amz-json-1.1',
            'x-amz-target': 'AWSCognitoIdentityService.GetCredentialsForIdentity'
          },
          body: JSON.stringify({
            IdentityId: identityId
          })
        });
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        const data = await response.json();
        const result = {
          accessKeyId: data.Credentials.AccessKeyId,
          expiration: data.Credentials.Expiration,
          secretKey: data.Credentials.SecretKey,
          sessionToken: data.Credentials.SessionToken
        };
        this.credential = result;
        return result;
      } catch {
        return undefined;
      } finally {
        this.fetchingCredentials = undefined;
      }
    };
    const fetchingCredentials = fetchCredentials();
    this.fetchingCredentials = fetchingCredentials;
    return fetchingCredentials;
  }
}